import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export interface User {
    wechatid: string;
    [key: string]: any;
}

@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(private router: Router) {}

    /**
     * Get user from cookie
     */
    get(): User | null {
        const cookies = document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            const cookiePair = cookies[i].split('=');

            if ('user' === cookiePair[0].trim()) {
                try {
                    return JSON.parse(decodeURIComponent(cookiePair[1]));
                } catch (e) {
                    console.error('Error parsing user cookie:', e);
                    return null;
                }
            }
        }
        return null;
    }

    /**
     * Logout user
     */
    logout(): void {
        document.cookie = 'user=; max-age=0';
        this.router.navigate(['/signin']);
    }
}
